import { Box } from "@ovou-inc/ovou-ui";
import { Fragment, ReactNode } from "react";
import { MessageBox } from "./MessageBox";

interface IMsgContainerProps {
  messages: IMsg[];
  showMsgs?: boolean;
}

export interface IMsg {
  type: "info" | "error";
  iconName?: string;
  // Usually a string (newline-split into <br/>-separated lines); callers can
  // also pass a node when part of the message needs its own styling
  // (e.g. a bold email).
  text: ReactNode;
}

export function MessagesContainer({
  messages,
  showMsgs = true,
}: IMsgContainerProps) {
  return messages.length > 0 && showMsgs ? (
    <Box>
      {messages.map((msg, msgIndex) => (
        <MessageBox
          key={msgIndex}
          type={msg.type}
          iconName={msg.iconName}
          marginTop={3}
        >
          {typeof msg.text === "string"
            ? msg.text.split(/\r?\n/).map((line, index) => (
                <Fragment key={line + index}>
                  {line}
                  <br />
                </Fragment>
              ))
            : msg.text}
        </MessageBox>
      ))}
    </Box>
  ) : null;
}
